export const config = {
  // API Configuration
  apiUrl: import.meta.env.VITE_API_URL || '/api',

  // App Configuration
  appName: import.meta.env.VITE_APP_NAME || 'Maschinenmatrix',
  appVersion: import.meta.env.VITE_APP_VERSION || '0.1.0',

  // Feature Flags
  features: {
    pwa: import.meta.env.VITE_ENABLE_PWA === 'true',
    darkMode: import.meta.env.VITE_ENABLE_DARK_MODE === 'true',
  },

  // File Upload Limits (in bytes)
  limits: {
    maxFileSize: parseInt(import.meta.env.VITE_MAX_FILE_SIZE || '157286400'), // 150MB
    maxImageSize: parseInt(import.meta.env.VITE_MAX_IMAGE_SIZE || '10485760'), // 10MB
  },

  // PDF.js Configuration
  pdfjs: {
    workerUrl: import.meta.env.VITE_PDF_WORKER_URL || '/pdf.worker.min.js',
  },

  // Theme Configuration
  theme: {
    defaultMode: 'light' as 'light' | 'dark',
    primaryColor: '#1976d2',
    secondaryColor: '#dc004e',
  },

  // Pagination
  pagination: {
    defaultPageSize: 20,
    pageSizeOptions: [10, 20, 50, 100],
  },

  // Notification
  notification: {
    defaultDuration: 5000,
    position: {
      vertical: 'top' as 'top' | 'bottom',
      horizontal: 'right' as 'left' | 'center' | 'right',
    },
  },

  // Development
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
};